import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';
import ArticleCard, { categoryName } from '@/components/base/ArticleCard';

export default function HotGossip() {
  const featured = articles.filter((a) => a.featured).slice(0, 1)[0];
  const side = articles.filter((a) => !a.featured).slice(0, 4);

  return (
    <section id="hot" className="w-full px-4 md:px-8 py-14 md:py-20">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-8">
        <div>
          <p className="flex items-center gap-2 text-xs tracking-widest text-primary-600">
            <i className="ri-fire-line" aria-hidden="true"></i>
            TODAY&apos;S HOT
          </p>
          <h2 className="mt-3 font-heading text-2xl md:text-4xl text-foreground-950">今日热瓜榜</h2>
          <p className="mt-3 text-sm text-foreground-600">大家今天反复回放的甜味瓜，从最上头的那条开始。</p>
        </div>
        <Link
          to="/fresh"
          className="self-start md:self-auto inline-flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
        >
          查看完整榜单
          <i className="ri-arrow-right-line" aria-hidden="true"></i>
        </Link>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-5">
        <Link
          to={`/article/${featured.slug}`}
          className="lg:col-span-7 group relative overflow-hidden rounded-2xl border border-background-200 bg-background-50 cursor-pointer"
        >
          <div className="w-full h-64 md:h-[420px] overflow-hidden bg-background-200">
            <img
              src={featured.cover}
              alt={featured.title}
              title={`${featured.title} - 糖心吃瓜`}
              className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
            />
          </div>
          <div className="absolute left-0 right-0 bottom-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/40 to-transparent p-5 md:p-7">
            <div className="flex items-center gap-2">
              <span className="rounded-full bg-primary-500 px-2.5 py-0.5 text-xs text-background-50">
                {categoryName(featured.category)}
              </span>
              <span className="rounded-full bg-background-50/15 px-2.5 py-0.5 text-xs text-background-50">
                热度 {featured.heat}
              </span>
            </div>
            <h3 className="mt-3 font-heading text-xl md:text-2xl text-background-50 leading-snug line-clamp-2">
              {featured.title}
            </h3>
            <p className="mt-2 hidden md:block text-sm text-background-100/85 line-clamp-2 leading-relaxed">
              {featured.excerpt}
            </p>
          </div>
        </Link>

        <div className="lg:col-span-5 flex flex-col gap-4">
          {side.map((a) => (
            <ArticleCard key={a.id} article={a} layout="horizontal" />
          ))}
        </div>
      </div>
    </section>
  );
}